import React, { PureComponent } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import './layout.scss'
import HeaderPage from '../../containers/layout/HeaderPage'
import FooterPage from '../../containers/layout/FooterPage'

class AdminLayout extends PureComponent {
  render () {
    return (
      <Grid fluid className="admin-layout">
        <Row>
          <HeaderPage sm={12} isAdmin={true} />
        </Row>
          <Col sm={12} className="main-container">
            {this.props.children}
          </Col>
        <Row>
          <FooterPage sm={12} />
        </Row>
      </Grid>
    )
  }
}

export default AdminLayout
